import {StyleSheet} from 'react-native';

const styles = {};

export default StyleSheet.create(styles);
